import React, { useEffect, useState } from "react";
import { format } from "date-fns";
import AppointmentOption from "./AppointmentOption";
import BookingModal from "../BookingModal/BookingModal";
import { useQuery } from "@tanstack/react-query";
import Loading from "../../../components/Loading/Loading";

const AvailableAppointments = ({ selectedDate }) => {
  // const [appointmentOptions, setAppointmentOptions] = useState([]);
  const [treatments, setTreatments] = useState(null);

  let daySelected = "";
  if (selectedDate) {
    daySelected = format(selectedDate, "PP");
  }

  // TanStack Query
  const fetchAppointmentOptions = async () => {
    try {
      const appointmentDate = await fetch(
        `https://doctors-portal-server-azure.vercel.app/appointmentOptions?date=${daySelected}`
        // {
        //   body: JSON.stringify(daySelected),
        // }
      );
      const data = await appointmentDate.json();
      return data;
      // setAppointmentOptions(data);
    } catch (err) {
      console.log(err);
    }
  };
  // Queries
  const {
    data: appointmentOptions,
    isLoading,
    refetch,
  } = useQuery({
    queryKey: ["appointmentOptions", daySelected],
    queryFn: fetchAppointmentOptions,
  });

  //   Load Appointment Options Data
  //   Needs change to server api link

  // useEffect(() => {
  //   fetchAppointmentOptions();
  // }, []);

  return (
    <div className="my-16">
      <p className="text-lg text-teal-500 text-center font-medium mb-5">
        Available Appointments on {daySelected}
      </p>

      {/* Loading data using tenStack  */}
      {isLoading ? (
        <Loading />
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5  mx-auto">
          {appointmentOptions.map((option) => (
            <AppointmentOption
              key={option._id}
              availableOption={option}
              setTreatments={setTreatments}
            />
          ))}
        </div>
      )}

      {treatments === null || (
        <BookingModal
          treatments={treatments}
          setTreatments={setTreatments}
          daySelected={daySelected}
          refetch={refetch}
        />
      )}
    </div>
  );
};

export default AvailableAppointments;
